import { find } from 'lodash';
import { TRADE_OBJECTS, ASSETS } from './constants';
import filter from 'lodash/filter';
import ui from '../../../../../data/ui.json';

// function mapping in format of trade object component
const getFieldDetails = (objKey, messages, value, code, showTooltip, toolTipContent, minValue, maxValue) => {

  const tradeObjects = ui.tradeOverview.tradeObjects;
  const tradeObject = find(tradeObjects, { key: objKey });
  tradeObject.title = messages[tradeObject.titleId];
  tradeObject.value = value;
  tradeObject.code = code;
  tradeObject.showTooltip = showTooltip;
  tradeObject.content = toolTipContent;
  tradeObject.id = objKey;
  return tradeObject;
};

// function for field mapping for the equities
const getEquitiesFields = (assetDetail, messages) =>{
  const data = [];
  const asset = {};
  if (assetDetail) {
    asset.chartHeaderValue = assetDetail.chartHeaderValue || null;
    asset.priceDate = assetDetail.priceDate && assetDetail.priceDate || null;
    asset.isin = assetDetail.isin || null;
    asset.averagePurchasePrice = assetDetail.averagePurchasePrice && assetDetail.averagePurchasePrice || null;
    asset.unrealisedGLPositionCurrency = assetDetail.unrealisedGLPositionCurrency || null;
    
    asset.defaultCurreny = assetDetail.positionCurrency;

    data.push(getFieldDetails(TRADE_OBJECTS.SECURITYPRICE, messages, asset.chartHeaderValue, assetDetail.chartHeaderValueUnit || asset.defaultCurreny  , false, ''));
    data.push(getFieldDetails(TRADE_OBJECTS.PRICE_DATE, messages, asset.priceDate, '' , false,'' ));
    data.push(getFieldDetails(TRADE_OBJECTS.ISIN, messages, asset.isin, '', false, ''));
    data.push(getFieldDetails(TRADE_OBJECTS.AVGPURCHASEPRICE, messages, asset.averagePurchasePrice,  assetDetail.averagePurchasePriceUnit || asset.defaultCurreny  , false,''));
    data.push(getFieldDetails(TRADE_OBJECTS.UNREALISEDGL, messages, asset.unrealisedGLPositionCurrency, assetDetail.unrealisedGLPositionCurrencyUnit || asset.defaultCurreny , false, ''));
  }
  return data;
}

// function for field mapping for the bonds
const getBondsFileds = (assetDetail, messages) => {
  const data = [];
  const assetBonds = {};
  if (assetDetail) {

    assetBonds.chartHeaderValue = assetDetail && assetDetail.chartHeaderValue;
    assetBonds.priceDate = assetDetail.priceDate && assetDetail.priceDate || null;
    assetBonds.isin = assetDetail.isin || null;
    assetBonds.accruedInterest = assetDetail.accruedInterest || null;
    assetBonds.averagePurchasePrice = assetDetail.averagePurchasePrice && assetDetail.averagePurchasePrice || null;
    assetBonds.unrealisedGLPositionCurrency = assetDetail.unrealisedGLPositionCurrency || null;
    assetBonds.rating = assetDetail.rating || null;

    assetBonds.defaultCurreny = assetDetail.positionCurrency;

    data.push(getFieldDetails(TRADE_OBJECTS.SECURITYPRICE, messages, assetBonds.chartHeaderValue, assetDetail.chartHeaderValueUnit || assetBonds.defaultCurreny , false, ''));
    data.push(getFieldDetails(TRADE_OBJECTS.PRICE_DATE, messages, assetBonds.priceDate, '' , false,'' ));
    data.push(getFieldDetails(TRADE_OBJECTS.ISIN, messages, assetBonds.isin, '', false, ''));
    data.push(getFieldDetails(TRADE_OBJECTS.ACCRUEDINTEREST, messages, assetBonds.accruedInterest,  assetDetail.accruedInterestUnit || assetBonds.defaultCurreny , false,''));
    data.push(getFieldDetails(TRADE_OBJECTS.AVGPURCHASEPRICE, messages, assetBonds.averagePurchasePrice,  assetDetail.averagePurchasePriceUnit || assetBonds.defaultCurreny , false,''));
    data.push(getFieldDetails(TRADE_OBJECTS.UNREALISEDGL, messages, assetBonds.unrealisedGLPositionCurrency, assetDetail.unrealisedGLPositionCurrencyUnit || assetBonds.defaultCurreny, false, ''));
    data.push(getFieldDetails(TRADE_OBJECTS.RATING, messages, assetBonds.rating, '', false, ''));

  }
  return data;
}

// common field mapping
const getDetailFields = (assetCategory, assetDetail, messages) => {

  if(assetCategory === ASSETS.EQUITY){

    return getEquitiesFields(assetDetail, messages);

  }
  if(assetCategory === ASSETS.BONDS){

    return getBondsFileds(assetDetail, messages);

  }
  return null;
}

export default getDetailFields

